import { useQuery } from "@tanstack/react-query"
import { httpKnowledgeBaseRepository } from "../../data/repositories/knowledge-base-repository"
import { makeGetKbUesConfig } from "../../domain/use-cases/get-kb-ues-config"

const getKbUesConfig = makeGetKbUesConfig(httpKnowledgeBaseRepository)

export const useKbUesConfig = (kbId: string) =>
  useQuery({
    queryKey: ["kbUesConfig", kbId],
    queryFn: () => getKbUesConfig(kbId),
    enabled: !!kbId,
  })
